import ConditionType from './ConditionType'

const ChangedCondition: ConditionType = {
  value: 'changed exactly',
  label: 'Changed Exactly',
  hasRHS: true,
  hasThreshold: true,
}

export default ChangedCondition
